import React from 'react';
import './TaskTable.css';
import { FaCheck } from 'react-icons/fa';

const resources = [
  { name: 'Sarah Chen', type: 'Human' },
  { name: 'AI Email Follow Up Template', type: 'AI' },
  { name: 'MacroPoint', type: 'Digital' },
  { name: 'FourKites', type: 'Digital' },
];

const TaskTable = ({ tasks, onAssign, onComplete }) => {
  const getPriorityClass = (priority) => {
    switch (priority) {
      case 'High': return 'priority-high';
      case 'Medium': return 'priority-medium';
      case 'Low': return 'priority-low';
      default: return '';
    }
  };

  return (
    <div className="task-table-wrapper">
      <table className="task-table">
        <thead>
          <tr>
            <th>Load ID</th>
            <th>Task Type</th>
            <th>Priority</th>
            <th>Resource Assigned</th>
            <th>ETA</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {tasks.map(task => (
            <tr key={task.id} className={`${task.completed ? 'completed' : ''} ${task.highlighted ? 'highlighted' : ''}`}>
              <td>
                <div className="cell-content">{task.loadId}</div>
                <div className="cell-sub-content">{task.deliveryInfo}</div>
              </td>
              <td>
                <div className="cell-content">{task.type}</div>
                <div className="cell-sub-content">Margin: {task.margin}</div>
              </td>
              <td><span className={`priority-tag ${getPriorityClass(task.priority)}`}>{task.priority}</span></td>
              <td>
                <div className="resource-cell">
                  <select
                    value={task.assigned}
                    onChange={(e) => onAssign(task.id, e.target.value)}
                    className="resource-select"
                  >
                    {resources.map(res => (
                      <option key={res.name} value={res.name}>
                        {res.name}
                      </option>
                    ))}
                  </select>
                </div>
              </td>
              <td>{task.eta}</td>
              <td><span className={`status-tag status-${task.status.toLowerCase().replace(' ', '-')}`}>{task.status}</span></td>
              <td>
                <button onClick={() => onComplete(task.id)} className="action-btn complete-btn">
                  <FaCheck /> Complete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default TaskTable;